import React from 'react';
import type { TimeRange } from '../hooks/useTimeSeries';

const RANGES: { label: string; value: TimeRange }[] = [
  { label: 'Live', value: 'live' },
  { label: '1D',   value: '1d'   },
  { label: '1W',   value: '1w'   },
  { label: '1M',   value: '1m'   },
  { label: '3M',   value: '3m'   },
];

interface TimeRangePickerProps {
  value: TimeRange;
  onChange: (r: TimeRange) => void;
}

export default function TimeRangePicker({ value, onChange }: TimeRangePickerProps) {
  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {RANGES.map(({ label, value: rv }) => {
        const active = value === rv;
        return (
          <button
            key={rv}
            onClick={() => onChange(rv)}
            style={{
              padding: '3px 10px',
              fontSize: 11,
              fontWeight: active ? 600 : 400,
              borderRadius: 4,
              border: `1px solid ${active ? '#6366f1' : '#2a3540'}`,
              background: active ? '#6366f1' : 'transparent',
              color: active ? '#fff' : '#7e8a96',
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
